// extracted by mini-css-extract-plugin
export default {"wrapper":"studentMain_wrapper__pTzyJ","content":"studentMain_content__B6wfI"};